/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  Cart,
  Order,
  OrderCartRequest,
  PaypalRequest,
  PaypalResponse,
  PaypalUpdateRequest,
  PurchaseItem,
  Redemption,
  Subscription,
  SubscriptionChangeRequest,
  SubscriptionChangeResponse,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    CartFromJSON,
    CartToJSON,
    OrderFromJSON,
    OrderToJSON,
    OrderCartRequestFromJSON,
    OrderCartRequestToJSON,
    PaypalRequestFromJSON,
    PaypalRequestToJSON,
    PaypalResponseFromJSON,
    PaypalResponseToJSON,
    PaypalUpdateRequestFromJSON,
    PaypalUpdateRequestToJSON,
    PurchaseItemFromJSON,
    PurchaseItemToJSON,
    RedemptionFromJSON,
    RedemptionToJSON,
    SubscriptionFromJSON,
    SubscriptionToJSON,
    SubscriptionChangeRequestFromJSON,
    SubscriptionChangeRequestToJSON,
    SubscriptionChangeResponseFromJSON,
    SubscriptionChangeResponseToJSON,
} from '../models';

export interface AddItemToCartRequest {
    xApplicationScope: ApplicationScope;
    purchaseItem: PurchaseItem;
}

export interface CancelOrderRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface DeleteItemFromCartRequest {
    xApplicationScope: ApplicationScope;
    cartItemId: string;
}

export interface EmptyCartRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCartRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetOrdersRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetProrationForSubscriptionRequest {
    xApplicationScope: ApplicationScope;
    subscriptionChangeRequest: SubscriptionChangeRequest;
}

export interface GetSubscriptionsForOrderRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface OrderCartOperationRequest {
    xApplicationScope: ApplicationScope;
    orderCartRequest: OrderCartRequest;
}

export interface RedeemVoucherRequest {
    xApplicationScope: ApplicationScope;
    redemption: Redemption;
}

export interface StartPaypalPaymentProcessRequest {
    xApplicationScope: ApplicationScope;
    paypalRequest: PaypalRequest;
}

export interface UpdatePaypalPaymentProcessRequest {
    xApplicationScope: ApplicationScope;
    paypalUpdateRequest: PaypalUpdateRequest;
}

/**
 * 
 */
export class OrderControllerApi extends runtime.BaseAPI {

    /**
     * add item to cart
     * add item to cart
     */
    async addItemToCartRaw(requestParameters: AddItemToCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling addItemToCart.');
        }

        if (requestParameters.purchaseItem === null || requestParameters.purchaseItem === undefined) {
            throw new runtime.RequiredError('purchaseItem','Required parameter requestParameters.purchaseItem was null or undefined when calling addItemToCart.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseItemToJSON(requestParameters.purchaseItem),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * add item to cart
     * add item to cart
     */
    async addItemToCart(requestParameters: AddItemToCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.addItemToCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * cancel an order
     * cancel an order
     */
    async cancelOrderRaw(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling cancelOrder.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cancelOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orders/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * cancel an order
     * cancel an order
     */
    async cancelOrder(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.cancelOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete item from cart
     * delete item from cart
     */
    async deleteItemFromCartRaw(requestParameters: DeleteItemFromCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteItemFromCart.');
        }

        if (requestParameters.cartItemId === null || requestParameters.cartItemId === undefined) {
            throw new runtime.RequiredError('cartItemId','Required parameter requestParameters.cartItemId was null or undefined when calling deleteItemFromCart.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current/{cartItemId}`.replace(`{${"cartItemId"}}`, encodeURIComponent(String(requestParameters.cartItemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * delete item from cart
     * delete item from cart
     */
    async deleteItemFromCart(requestParameters: DeleteItemFromCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.deleteItemFromCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * empty cart
     * empty cart
     */
    async emptyCartRaw(requestParameters: EmptyCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling emptyCart.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * empty cart
     * empty cart
     */
    async emptyCart(requestParameters: EmptyCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.emptyCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get cart
     * get cart
     */
    async getCartRaw(requestParameters: GetCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCart.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * get cart
     * get cart
     */
    async getCart(requestParameters: GetCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.getCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get orders
     * get orders
     */
    async getOrdersRaw(requestParameters: GetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Order>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getOrders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderFromJSON));
    }

    /**
     * get orders
     * get orders
     */
    async getOrders(requestParameters: GetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Order>> {
        const response = await this.getOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get proration for subscription
     * get proration for subscription
     */
    async getProrationForSubscriptionRaw(requestParameters: GetProrationForSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionChangeResponse>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getProrationForSubscription.');
        }

        if (requestParameters.subscriptionChangeRequest === null || requestParameters.subscriptionChangeRequest === undefined) {
            throw new runtime.RequiredError('subscriptionChangeRequest','Required parameter requestParameters.subscriptionChangeRequest was null or undefined when calling getProrationForSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/subscription/change`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionChangeRequestToJSON(requestParameters.subscriptionChangeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionChangeResponseFromJSON(jsonValue));
    }

    /**
     * get proration for subscription
     * get proration for subscription
     */
    async getProrationForSubscription(requestParameters: GetProrationForSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionChangeResponse> {
        const response = await this.getProrationForSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get subscriptions associated with order
     * get subscriptions associated with order
     */
    async getSubscriptionsForOrderRaw(requestParameters: GetSubscriptionsForOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Subscription>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getSubscriptionsForOrder.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSubscriptionsForOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orders/{id}/subscriptions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionFromJSON));
    }

    /**
     * get subscriptions associated with order
     * get subscriptions associated with order
     */
    async getSubscriptionsForOrder(requestParameters: GetSubscriptionsForOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Subscription>> {
        const response = await this.getSubscriptionsForOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * place order with all items of current cart
     * place order with all items of current cart
     */
    async orderCartRaw(requestParameters: OrderCartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling orderCart.');
        }

        if (requestParameters.orderCartRequest === null || requestParameters.orderCartRequest === undefined) {
            throw new runtime.RequiredError('orderCartRequest','Required parameter requestParameters.orderCartRequest was null or undefined when calling orderCart.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current/order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCartRequestToJSON(requestParameters.orderCartRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * place order with all items of current cart
     * place order with all items of current cart
     */
    async orderCart(requestParameters: OrderCartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.orderCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * redeem voucher for current cart
     * redeem voucher for current cart
     */
    async redeemVoucherRaw(requestParameters: RedeemVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling redeemVoucher.');
        }

        if (requestParameters.redemption === null || requestParameters.redemption === undefined) {
            throw new runtime.RequiredError('redemption','Required parameter requestParameters.redemption was null or undefined when calling redeemVoucher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current/vouchers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedemptionToJSON(requestParameters.redemption),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * redeem voucher for current cart
     * redeem voucher for current cart
     */
    async redeemVoucher(requestParameters: RedeemVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.redeemVoucherRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * start paypal payment process
     * start paypal payment process
     */
    async startPaypalPaymentProcessRaw(requestParameters: StartPaypalPaymentProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaypalResponse>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling startPaypalPaymentProcess.');
        }

        if (requestParameters.paypalRequest === null || requestParameters.paypalRequest === undefined) {
            throw new runtime.RequiredError('paypalRequest','Required parameter requestParameters.paypalRequest was null or undefined when calling startPaypalPaymentProcess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orders/paypal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaypalRequestToJSON(requestParameters.paypalRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaypalResponseFromJSON(jsonValue));
    }

    /**
     * start paypal payment process
     * start paypal payment process
     */
    async startPaypalPaymentProcess(requestParameters: StartPaypalPaymentProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaypalResponse> {
        const response = await this.startPaypalPaymentProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update paypal payment process
     * update paypal payment process
     */
    async updatePaypalPaymentProcessRaw(requestParameters: UpdatePaypalPaymentProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updatePaypalPaymentProcess.');
        }

        if (requestParameters.paypalUpdateRequest === null || requestParameters.paypalUpdateRequest === undefined) {
            throw new runtime.RequiredError('paypalUpdateRequest','Required parameter requestParameters.paypalUpdateRequest was null or undefined when calling updatePaypalPaymentProcess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orders/paypal/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaypalUpdateRequestToJSON(requestParameters.paypalUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * update paypal payment process
     * update paypal payment process
     */
    async updatePaypalPaymentProcess(requestParameters: UpdatePaypalPaymentProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.updatePaypalPaymentProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
